import { ref } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'
import store from '@/store'
const devices = ref([])
const  owners=ref([]);
const contracts=ref([]);
const containers=ref([]);
const  geofences=ref([]);
const  types=ref([]);

const plans=ref([])
const filterdata=ref({

  type:'device',
      
  user: store.state.auth.userData.id
});


const planfilterdata=ref({

  type:"plan",
  planType:'garden',
  cols:"id,name",
  user: store.state.auth.userData.id
});

const geofencefilterdata=ref({

  type:"geofence",
 
  user: store.state.auth.userData.id
});

const reFilterPlans=(name,data)=>{

  if(name=="owners"){
  
    planfilterdata.value.owner=data.owners;
 
   }else if(name=="contracts"){

    planfilterdata.value.contract=data.contracts;
   
   }

   ReportService.getDevicesOptions(
    planfilterdata.value
  ).then(response => {devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name}))})

  
  ReportService.getPlanOptions(
    planfilterdata.value
   
    
   ).then(response =>{   plans.value = response.data})




}


const reFilterGeofences =(name,data)=>{
  
  if(name=="owners"){
    console.log(data)
    geofencefilterdata.value.owner=data.areas_owners;
 
   }else if(name=="contracts"){

    geofencefilterdata.value.contract=data.areas_contracts;
   }


   ReportService.getAreasOptions(
    geofencefilterdata.value
    ).then(response => geofences.value = response.data.map((d)=>({id:d.geofence_id,"name":d.name})))

}

const reFilterDevices=(name,data)=>{
  
    if(name=="owners"){
     filterdata.value.owner=data.owners;
  
    }else if(name=="contracts"){
 
     filterdata.value.contract=data.contracts;
    
   }else if(name=="geofences"){
 
     filterdata.value.geofence=data.geofences;
    
    }else if(name=="types"){
      filterdata.value.types=data.types;

    }else if(name=="containers"){
      filterdata.value.container=data.containers;

    }
    
     ReportService.getDevicesOptions(
       filterdata.value
     ).then(response => {
       
       devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name}))
      })
   
   
 
   }



   const reFilterSupportDevices=(name,data)=>{
  
    if(name=="owners"){
     filterdata.value.owner=data.owners;
  
    }else if(name=="contracts"){
 
     filterdata.value.contract=data.contracts;
    
   }else if(name=="geofences"){
 
     filterdata.value.geofence=data.geofences;
    
    }else if(name=="types"){
      filterdata.value.types=data.types;

    }else if(name=="containers"){
      filterdata.value.container=data.containers;

    }
    
     ReportService.getDevicesOptions(
       Object.assign(filterdata.value,{isSupport:true})
     ).then(response => {
       
       devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name}))
      })
   
   
 
   }
   ReportService.getDevicesOptions({
    type:'user',
    user: store.state.auth.userData.id,
    isOwner:true
  }).then(response =>{ owners.value = response.data})


   export {plans,devices,owners,contracts,geofences,types,containers,filterdata,planfilterdata,reFilterDevices,reFilterPlans,reFilterGeofences,reFilterSupportDevices}